<template>
<ButtonPrimary v-on="$listeners" class="v-btn--assignment-remove ButtonAssignmentRemove">
  <template v-slot:icon>
    <Icon />
  </template>
  <template v-slot:text>
    {{$t('buttons.assignmentRemove')}}
  </template>
</ButtonPrimary>
</template>

<script>
import ButtonPrimary from "./templates/ButtonPrimary";
import Icon from "../icons/AssignmentRemoveIcon";
export default {
  name: "ButtonAssignmentRemove",
  components: {Icon, ButtonPrimary}
}
</script>

<style scoped lang="scss">
</style>

<!-- The following style have to be declared as global styles, otherwise they have no effect. -->
<style lang="scss">
.v-btn--assignment-remove {
  svg {
    .c {
      stroke: $white;
    }
  }

  &:hover {
    svg {
      .a, .b {
        fill: map-get($green, 'base');
        stroke: $white;
      }

      .c {
        stroke: map-get($green, 'base');
      }
    }
  }
}
</style>
